"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Renderer_1 = __importDefault(require("../../classes/Renderer"));
class MediaGroupRendererData extends Renderer_1.default {
    async getDocumentTemplateData() {
        const { medias, documentItemType } = this.args;
        const mediaSizeSuffix = documentItemType.split('-')[1];
        return {
            data: {
                description: this.item.data.description,
                title: this.item.data.title,
            },
            mediaItems: medias.map(item => ({ url: item.data.url })),
            mediaSizeClass: mediaSizeSuffix ? `media-${mediaSizeSuffix}` : '',
            type: documentItemType,
        };
    }
}
exports.default = MediaGroupRendererData;
//# sourceMappingURL=../../../../src/models/mediaGroup/rendererData.js.map